import { render } from "./footersection.vue?vue&type=template&id=473ded30"
import script from "./footersection.vue?vue&type=script&lang=js"
export * from "./footersection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__